import api from './api';
import queryString from 'query-string';

const resource = 'Tag/';

export const createPlatformTag = async (body) => {
  return await api.post(resource + 'platform-tag', body);
};

export const getPlatformTagById = async (id) => {
  return await api.get(resource + 'get-platform-tag/' + id);
};

export const getPlatformTags = async () => {
  return await api.get(resource + 'get-platform-tags');
};

export const updatePlatformTag = async (body) => {
  return await api.put(resource + 'update-platform-tag', body);
};

export const deletePlatformTagByProductId = async (id) => {
  return await api.delete(
    resource + 'delete-platform-tag/by-product-id?id=' + id
  );
};

export const createTag = async (body) => {
  return await api.post(resource + 'tag', body);
};

export const getTagById = async (id) => {
  return await api.get(resource + 'get-tag/' + id);
};

export const getTags = async (query) => {
  return await api.get(
    resource +
      `get-tags?${queryString.stringify(query, {
        skipNull: true,
      })}`
  );
};

export const updateTag = async (body) => {
  return await api.put(resource + 'update-tag', body);
};

export const deleteTag = async (id) => {
  return await api.delete(resource + 'delete-tag/-id?id=' + id);
};

export const createCustomProductTag = async (body) => {
  return await api.post(resource + 'custom-product-tag', body);
};

export const getCustomProductTagById = async (id) => {
  return await api.get(resource + 'get-custom-product-tag/' + id);
};

export const getCustomProductTags = async (query) => {
  return await api.get(
    resource +
      `get-custom-product-tags?${queryString.stringify(query, {
        skipNull: true,
      })}`
  );
};

export const updateCustomProductTag = async (body) => {
  return await api.put(resource + 'update-custom-product-tag', body);
};

export const deleteCustomProductTag = async (id) => {
  return await api.delete(resource + 'delete-custom-product-tag/-id?id=' + id);
};

export const savePlatformTagsForProduct = async (productId, platformTags) => {
  const body = {
    productId: productId,
    isWeb: platformTags.isWeb || false,
    isKiosk: platformTags.isKiosk || false,
    isMobile: platformTags.isMobile || false,
  };
  return await api.post(resource + 'platform-tag', body);
};

export const saveCustomTagsForProduct = async (productId, customTags) => {
  const promises = customTags.map((tag) => {
    const body = {
      productId: productId,
      tagId: tag.id,
    };
    return api.post(resource + 'custom-product-tag', body);
  });
  return await Promise.all(promises);
};

const tagApi = {
  createPlatformTag,
  getPlatformTagById,
  getPlatformTags,
  updatePlatformTag,
  deletePlatformTagByProductId,
  createTag,
  getTagById,
  getTags,
  updateTag,
  deleteTag,
  createCustomProductTag,
  getCustomProductTagById,
  getCustomProductTags,
  updateCustomProductTag,
  deleteCustomProductTag,
  savePlatformTagsForProduct,
  saveCustomTagsForProduct,
};

export default tagApi;
